import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router'

import {usePageData} from '_metronic/layout/core'

import Parent from './components/user/Parent'
import Student from './components/user/Student'
import VendorAdd from './components/vendors/Add'
import VendorList from './components/vendors/List'

const HelpPopup: FC = () => {
  const intl = useIntl()
  const {pageTitle} = usePageData()
  const {pathname} = useLocation()

  const [componentTitle, setComponentTitle] = useState('')
  const [showModal, setShowModal] = useState(false)

  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleHideModal = () => {
    setShowModal(false)
  }

  let Component
  switch (pathname.toLocaleLowerCase()) {
    case '/institute/user/student':
      Component = Student
      break
    case '/institute/user/parent':
      Component = Parent
      break
    case '/institute/vendors/list':
      Component = VendorList
      break
    case '/institute/vendors/add':
      Component = VendorAdd
      break
  }

  if (!Component) {
    return null
  }

  return (
    <>
      <div className='d-flex align-items-center py-1'>
        <div className='me-4'>
          <button
            type='button'
            className='btn btn-sm btn-flex btn-light-primary fw-bolder'
            onClick={handleShowModal}
          >
            <span className='fa fa-circle-info mx-1'></span>
            {intl.formatMessage({id: 'GENERAL.HELP'})}
          </button>
        </div>
      </div>

      <Modal show={showModal} onHide={handleHideModal} size='lg' centered>
        <Modal.Header closeButton>
          <Modal.Title>{componentTitle !== '' ? componentTitle : pageTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Component setTitle={(title: string) => setComponentTitle(title)} />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default HelpPopup
